module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.ffaae0e1.woff2";